import { observer } from 'mobx-react-lite';
import { API_BASE_URL } from '../../__common/env';
import { useMainContext } from '../../hooks/useMainContext';
import { FaRegUserCircle } from 'react-icons/fa';
import { PageTypes } from '../../config';
import { STEP_TYPE } from '../../__utils/UiConst';
import { IoClose } from 'react-icons/io5';
import { HeaderButtons } from '../Header/HeaderButtons';
import Button from '../Globle/Button';
import { LiaSave } from 'react-icons/lia';
import RoundedButton from '../Globle/RoundedButton';
import { VscLock } from 'react-icons/vsc';
import UserMenu from '../Header/UserMenu';

const Header = observer(() => {
    const { viewManager, uiManager, closetManager, operationsManager } =
        useMainContext();
    const isDisabled = !viewManager.doUserHasAccess();
    function clearQueryParams() {
        const url = new URL(window.location.href);
        url.search = '';
        window.history.pushState({}, '', url);
    }
    const isWorkSpace =
        viewManager.currentPage === PageTypes.WorkSpace &&
        uiManager.selectedStep !== STEP_TYPE.CREATE;

    const handleClick = async () => {
        if (isDisabled) return;
        closetManager.setIsSaving(true);
        await operationsManager.downloadClosetData();
        closetManager.setIsSaving(false);
    };
    return (
        <div className="h-[80px] flex items-center justify-between pl-[32px] pr-[16px] border-b-[1px] border-theme-border">
            {isWorkSpace && (
                <div className="flex items-center ">
                    <img src={`${API_BASE_URL}/assets/logo/logo2.svg`} alt="" />
                    <div className="h-[38px] px-[16px] flex items-center py-[5px] border-l-[1px] border-theme-border ml-[16px]">
                        <h2 className="font-favorit text-[24px] leading-[24px] text-theme-black font-normal">
                            {viewManager.formData?.projectName}
                        </h2>
                    </div>
                </div>
            )}
            {(viewManager.currentPage === PageTypes.HomePage ||
                uiManager.selectedStep === STEP_TYPE.CREATE) && (
                <HomePageHeader />
            )}
            {isWorkSpace && (
                <div className="flex items-center gap-[8px]">
                    <HeaderButtons />
                    {/* <RoundedButton
                        className="w-[48px] h-[48px] group pointer-events-none"
                        icon={
                            <VscLock className="text-[24px] group-hover:text-theme-white" />
                        }
                    /> */}
                    <Button
                        label={'Save'}
                        iconClass="!text-[24px] !ml-0 !mr-1 mb-[3px]"
                        className="w-[116px] flex items-center justify-center bg-theme-header-bg text-[16px] font-[700]"
                        icon={LiaSave}
                        onClick={handleClick}
                        loading={closetManager.isSaving}
                        disabled={isDisabled}
                    />
                    <Button
                        label={'Quote Project'}
                        className="w-[151px] flex items-center justify-center bg-theme-header-bg text-[16px] font-[700]"
                        disabled={true}
                    />
                    <IoClose
                        className="w-[24px] h-[24px] cursor-pointer text-theme-black ml-[12px]"
                        onClick={() => {
                            clearQueryParams();
                            window.location.reload();
                        }}
                    />
                </div>
            )}
        </div>
    );
});

export default Header;

const HomePageHeader = observer(() => {
    const { viewManager } = useMainContext();
    return (
        <>
            <img
                onClick={() => {
                    viewManager.setCurrentPage(PageTypes.HomePage);
                }}
                src={`${API_BASE_URL}/assets/logo/logo2.svg`}
                alt=""
                className="cursor-pointer"
            />
            <UserMenu />
        </>
    );
});
